import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/')({
  beforeLoad: () => {
    throw redirect({ to: '/clearing/operations' });
  },
  preload: false,
});
